/**
 * "Enum" of server returned package names
 */
export const PACKAGES = {
  Basic: 'BASIC',
  StandardMonthly: 'STANDARD_MONTHLY',
  StandardAnnual: 'STANDARD_ANNUAL',
  AdvantageMonthly: 'ADVANTAGE_MONTHLY',
  AdvantageAnnual: 'ADVANTAGE_ANNUAL',
  PremierMonthly: 'PREMIER_MONTHLY',
  PremierAnnual: 'PREMIER_ANNUAL',
  TeamAdvantage: 'TEAM_ADVANTAGE_ANNUAL',
  TeamPremier: 'TEAM_PREMIER_ANNUAL',
  Enterprise: 'ENT_PLATINUM',
  Flex: 'ANALYZE_MONTHLY',
};

/**
 * To do package ID lookups from a package name
 */
export const PACKAGE_IDS = {
  [PACKAGES.Basic]: 1,
  [PACKAGES.StandardMonthly]: 31,
  [PACKAGES.StandardAnnual]: 32,
  [PACKAGES.AdvantageMonthly]: 33,
  [PACKAGES.AdvantageAnnual]: 34,
  [PACKAGES.PremierMonthly]: 35,
  [PACKAGES.PremierAnnual]: 36,
  [PACKAGES.TeamAdvantage]: 134,
  [PACKAGES.TeamPremier]: 136,
  [PACKAGES.Enterprise]: 26,
  [PACKAGES.Flex]: 37,
};

export const MONTHLY_PACKAGES = [PACKAGES.StandardMonthly, PACKAGES.AdvantageMonthly, PACKAGES.PremierMonthly];

export const INDIVIDUAL_PACKAGES = [PACKAGES.PremierAnnual, PACKAGES.AdvantageAnnual, PACKAGES.StandardMonthly];

export const TEAMS_PACKAGES = [PACKAGES.TeamAdvantage, PACKAGES.TeamPremier, PACKAGES.Enterprise];

export const SUITE_PRICING_PACKAGES = [PACKAGES.AdvantageAnnual, PACKAGES.TeamAdvantage, PACKAGES.TeamPremier];

export const GUAC_COUNTRY_CODES = ['gb', 'us', 'au', 'ca'];

export const TEAM_COMPARISON_PACKAGES = {
  [PACKAGES.TeamAdvantage]: PACKAGES.AdvantageAnnual,
  [PACKAGES.TeamPremier]: PACKAGES.PremierAnnual,
};

// A list of packages that should display highlighted
export const HIGHLIGHTED_PACKAGES = [PACKAGES.AdvantageAnnual];
